import { createContext, useReducer } from "react";
//import questions from "../data";
import { shuffleAnswers } from "../helper";

const initialState = {
  currentQuestionIndex: 0,
  questions: [],
  showResults: false,
  answers: [], //shuffleAnswers(questions[0]),
  currentAmswer: "",
  countcorrectAnswer: 0,
  errorMsg: null,
};

const reducer = (state, action) => {
  if (action.type === "SERVER_ERROR") {
    return {
      ...state,
      errorMsg: action.payload,
    };
  }

  if (action.type === "FETCHED") {
    return {
      ...state,
      questions: action.payload,
      answers: shuffleAnswers(action.payload[0]),
    };
  }
  if (action.type === "SELECT_ANSWER") {
    // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$", action.payload);
    let countcorrectAnswer = state.countcorrectAnswer;
    if (
      action.payload ===
      state.questions[state.currentQuestionIndex].correct_answer
    ) {
      countcorrectAnswer = countcorrectAnswer + 1;
    }
    return {
      ...state,
      currentAmswer: action.payload,
      countcorrectAnswer: countcorrectAnswer,
    };
  }
  if (action.type === "NEXT_QUESTION") {
    const showResults =
      state.currentQuestionIndex === state.questions.length - 1;
    const currentQuestionIndex = showResults
      ? state.currentQuestionIndex
      : state.currentQuestionIndex + 1;
    const answers = showResults
      ? []
      : shuffleAnswers(state.questions[currentQuestionIndex]);
    return {
      ...state,
      currentQuestionIndex,
      showResults,
      answers: answers,
      currentAmswer: "",
    };
  }
  if (action.type === "RESTART") {
    return initialState;
  }
  return state;
};

export const QuizContext = createContext();

export const QuizProvider = ({ children }) => {
  const value = useReducer(reducer, initialState);
  console.log("state", value);
  return <QuizContext.Provider value={value}>{children}</QuizContext.Provider>;
};
